import createVueComponent from '../createVueComponent';

const ArrowBigLeft = createVueComponent('ArrowBigLeftIcon', [
  ['path', { d: 'M18 15h-6v4l-7-7 7-7v4h6v6z', key: 'lbrdak' }],
]);

export default ArrowBigLeft;
